import React from 'react';
import PropTypes from 'prop-types';
import { PopoverItem } from '../ui/Popover';
import { qa } from '../api';

const ResolveIssue = ({ projectID, issue, doAction }) => (
  <PopoverItem
    label="Resolve"
    onClick={() => doAction(qa.resolveIssue(projectID, issue.id))}
  />
);

ResolveIssue.propTypes = {
  projectID: PropTypes.string.isRequired,
  issue: PropTypes.object.isRequired,
  doAction: PropTypes.func.isRequired,
};

export default ResolveIssue;
